import { format, parseISO, differenceInDays, differenceInYears, differenceInMonths, addMonths, subDays, subMonths, isValid, endOfMonth, startOfMonth, getMonth } from 'date-fns';
import es from 'date-fns/locale/es';
export const esFechaValida = ({ date }) => {
    if (!date)
        return false
    return isValid(date)
}
export const FormatFecha = (date) => {
    return format(date, 'yyyy-MM-dd', { locale: es });
}
export const FormatoFecha = ({ date, formato }) => {
    if (!date)
        return null
    return format(date, formato, { locale: es });
}
export const FormatoFechaIso = ({ date, formato = "dd-MM-yyyy" }) => {
    if (!date)
        return null
    return format(parseISO(date), formato, { locale: es });
}

export const FormatoDiff = ({ date }) => {
    if (!date)
        return null
    return differenceInDays(parseISO(date), new Date());
}
export const FormatoDiffDate = ({ date }) => {
    if (!date)
        return null
    return differenceInDays(date, new Date());
}

export const FormatoDiffYear = ({ date }) => {
    if (!date)
        return null
    return differenceInYears(new Date(), parseISO(date));
}

export const FormatoDiffMount = ({ date }) => {
    if (!date)
        return null
    return differenceInMonths(parseISO(date), new Date());
}
export const formatAddMonth = ({ months }) => {
    const today = new Date()
    return format(addMonths(today, months), "yyyy MM dd", { locale: es })
}
export const formatAddMonthformat = ({ months }) => {
    const today = new Date()
    return format(addMonths(today, months), "MMddyyyy", { locale: es })
}
export const formatSubMonthIso = ({ date, months, formato }) => {
    if (!date)
        return null
    return format(subMonths(parseISO(date), months), formato, { locale: es })
}
export const formatSubDaysIso = ({ date, days, formato }) => {
    if (!date)
        return null
    return format(subDays(parseISO(date), days), formato, { locale: es })
}

export const formatEndMounth = ({ date, formato }) => {
    if (!date)
        return null
    return format(endOfMonth(date), formato, { locale: es })
}
export const formatStartMounth = ({ date, formato }) => {
    if (!date)
        return null
    return format(startOfMonth(date), formato, { locale: es })
}
export const endMounth = ({ date }) => {
    if (!date)
        return null
    return endOfMonth(date)
}
export const startMounth = ({ date }) => {
    if (!date)
        return null
    return startOfMonth(date)
}